function resetState(state, data) {
    Object.keys(data).forEach((key) => {
      state[key] = data[key]
    })
  }

  export {resetState}